// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1nyhF","emails":"CreateEditClinics_emails__2b0FM","emailTagLabel":"CreateEditClinics_emailTagLabel__2cRm9"};